import * as React from "react";
import Layout from "../components/layout";
import { Link } from "gatsby";

const IndexPage = () => {
  return (
    <Layout>
      <div className="flex flex-row align-center sm:text-left mt-5 sm:mt-20 mb-10 sm:mb-20">
        <h1 className="leading-snug days-one text-3xl sm:text-5xl font-extrabold">
          <span className="span1">Je code et je fais du vélo, </span>
          <br />
          <span className="span2">rarement les deux en même temps.</span>
        </h1>
      </div>
      <Link
        to="/blog"
        activeClassName="active"
        className="bg-text-main text-primary px-6 py-2 hover:border-2 hover:border-violet-900 hover:bg-white hover:text-text-main rounded-xl dark:hover:border-white dark:hover:white dark:hover:bg-primary"
      >
        Découvrez mes articles
      </Link>
      <section className="flex flex-col md:flex-row w-full mt-20">
        <div class="bg-white shadow-md rounded-xl mb-5 w-full">
          <div className="bg-indigo-100 p-5 mb-5">
            <div>
              <strong>Languages et outils</strong>
            </div>
          </div>
          <div className="flex flex-row flex-wrap p-5">
            <img
              className="rounded-full h-10 w-10"
              src={
                "https://icones.pro/wp-content/uploads/2021/05/icone-html-orange.png"
              }
              alt="html logo"
            />
            <img
              className="rounded-full h-10 w-10 ml-3"
              src={
                "https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582747_1280.png"
              }
              alt="css logo"
            />
            <img
              className="rounded-full h-10 w-10 ml-3"
              src={
                "https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Unofficial_JavaScript_logo_2.svg/800px-Unofficial_JavaScript_logo_2.svg.png"
              }
              alt="javascript logo"
            />
            <img
              className="rounded-full h-10 w-10 ml-3"
              src={
                "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Angular_full_color_logo.svg/langfr-220px-Angular_full_color_logo.svg.png"
              }
              alt="angular logo"
            />
            <img
              className="rounded-full h-10 w-10 ml-3"
              src={
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRfu6tSzQMwbMGqdYtNjyBcwUvu2pZDHml7rFMduZUyW-YbDhFv_1zxO3U2hurSMOt4850&usqp=CAU"
              }
              alt="c# logo"
            />
            <img
              className="rounded-full h-10 w-10 ml-3"
              src={
                "https://img1.freepng.fr/20180705/lxg/kisspng-sql-database-computer-icons-download-sql-icon-5b3ed4c99e96a6.5791410715308443616496.jpg"
              }
              alt="sql logo"
            />
            <img
              className="rounded-full h-10 w-10 ml-3"
              src={
                "https://ih1.redbubble.net/image.1470587088.2816/st,small,507x507-pad,600x600,f8f8f8.jpg"
              }
              alt="VS CODE logo"
            />
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default IndexPage;